export const ritualSteps = [
  { title: 'Voorbereiding', text: 'De huid verwarmen en voorbereiden.', products: [] },
  { title: 'Reinigen', text: 'De huid zuiveren met traditionele Marokkaanse verzorging.', products: ['Savon Beldi'] },
  { title: 'Scrubben', text: 'Dode huidcellen verwijderen met de Kessa.', products: ['Kessa', "M'hekka"] },
  { title: 'Behandelen', text: 'De huid verzorgen met een traditionele klei- en bodytreatment.', products: ['Ghassoul', 'Nila', 'Tbrima'] },
  { title: 'Voeding', text: 'Haar en hoofdhuid verzorgen.', products: ['Henna Sidr', 'Arganolie'] },
  { title: 'Afspoelen', text: 'De huid grondig afspoelen.', products: [] },
  { title: 'Opfrissen', text: 'Een verfrissende bloemenmist aanbrengen.', products: ['Rozenwater', 'Oranjebloesemwater'] },
  { title: 'Hydrateren', text: 'De huid intensief verzorgen met olie of body butter.', products: ['Arganolie', 'Cactusvijgolie'] },
  { title: 'Afwerken', text: 'De finishing touch met geur en verzorging.', products: ['Musk', 'Oud'] },
]
